import { FaTools, FaShieldAlt, FaUsers } from "react-icons/fa";

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Protect Your Home with Premium Roofing Solutions",
    content: "At Roofing Experts, we are dedicated to providing top-quality roofing services that ensure the safety, durability, and beauty of your home.",
    points: [
        {
            id: 1,
            icon: <FaTools />,
            title: "Custom Roofing Solutions",
            content: "We offer tailored roofing solutions designed to meet your specific needs and preferences, ensuring your home is both secure and stylish.",
        },
        {
            id: 2,
            icon: <FaShieldAlt />,
            title: "Unmatched Quality Assurance",
            content: "Our commitment to quality means that every roofing project we undertake is completed with precision, using the best materials for long-lasting results.",
        },
        {
            id: 3,
            icon: <FaUsers />,
            title: "Experienced Professional Team",
            content: "Our skilled and experienced roofing professionals ensure that every installation or repair is carried out to the highest standards.",
        },
    ]
};

export default whyChooseUs;